<template>
  <div class="selector-transferencias">
    <v-toolbar color="grey lighten-2" absolute flat height="22em" tabs>
      <template slot="extension">
        <v-tabs v-model="currentTab" centered flat icons-and-text class="pb-4" color="grey lighten-2">
           <v-tab href="#tab-1" to="/selector-transferencias/transferencias" v-if="this.$store.state.permissions.canViewTransferenciasJugadores" >
            <span>Transferencias</span>
            <v-icon>mdi-transit-transfer</v-icon>
          </v-tab>
          <v-tab href="#tab-2" to="/selector-transferencias/cedidos" v-if="this.$store.state.permissions.canViewJugadoresCedidos">
            <span>Cedidos a préstamo</span>
            <v-icon>mdi-bank-transfer</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <div class="top-spacing">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {

  data () {
    return {
      currentTab: null,
      tabs: [
        { id: 1, componentName: 'transferencias' },
        { id: 2, componentName: 'cedidos' }
      ]
    }
  },
  mounted () {
    if (this.currentTab === '/selector-transferencias/transferencias') {
      this.$router.push({ name: 'finalizados-transferencias' })
    }
    if (this.currentTab === '/selector-transferencias/cedidos') {
      this.$router.push({ name: 'cedidos' })
    }
  }
}
</script>

<style scoped>
.top-spacing {
  margin-top: 5em;
}
</style>
